module.exports = __webpack_public_path__ + "static/img/12.26099b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/12.png
// module id = P7Mx
// module chunks = 0